<template>
  <SelectActivityRenderer
      ref="sizeRenderer"
      :field-config="fieldConfig"
      :validated-field="validatedField"
      :mode="mode"
      :custom-mode="true"
      @custom-mode-event="showSizeRecords"
  >
  </SelectActivityRenderer>
</template>

<script>

import ReachSelect from "@/components/inputs/ReachSelect";
import FormValidatedField from "@/components/forms/FormValidatedField";
import Size from "@/server/com/silkplm/model/plm/dictionaries/Size";
import SelectFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig";
import SelectActivityRenderer from "@/components/forms/renderers/SelectActivityRenderer";
import FormsActions from "@/components/forms/FormsActions";
import FormModel from "@/components/forms/FormModel";
import _ from "lodash";

export default {
  name: "SizeRenderer",
  components: {SelectActivityRenderer, ReachSelect},

  async mounted() {
    this.readOnly = true;
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    async showSizeRecords(){
      let recordFormModel = new FormModel(FormsLoader.detectFormConfig(this.parentForm.formConfig.formClassLong));
      let originalSource = await recordFormModel.newEntity();
      originalSource["category"] = this.parentForm.fields.category.value;
      // sprawdzić czy istnieją już jakieś inne rekordy size mapping do tej kategorii
      let allRecords = await Rpc.Forms.
        listDictionaryValues(this.parentForm.formConfig.formClassLong, this.fieldConfig.fieldName, originalSource).lock();
      let categoryId = this.parentForm.fields.category.value;
      let currentlyAddedSizesToCategory = await Rpc.plm.services.DimensionalService.
        listCurrentlyAddedSizesToCategory(categoryId).lock();
      let onlyIds = [];
      allRecords.forEach((el) => {
        let sizeToAdded = _.find(currentlyAddedSizesToCategory, {id: el.id});
        if(!sizeToAdded){
          onlyIds.push(el.id);
        }
      })
      let records = await (await FormsActions.showMultiSelectListFromIds(Size, {}, onlyIds)).getResult();
      if(!records){
        return;
      }
      let recordsFormModelToSave = [];
      for (let record of records) {
        let originalSource = await recordFormModel.newEntity();
        originalSource["category"] = this.parentForm.fields.category.value;
        originalSource[this.fieldConfig.fieldName] = record.id;
        recordsFormModelToSave.push(recordFormModel.originalSource);
      }
      await Rpc.Forms.addEntities(this.parentForm.formConfig.formClassLong, recordsFormModelToSave).lock();
      let topActivity = ActivityManager.getTopActivity();
      await topActivity.close(true);
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: SelectFormFieldConfig, required: true},
    parentForm: {default: null},
    mode: {default: null}
  },

  watch: {
    'parentForm.fields.category.isValid': function (val) {
      if(this.parentForm.fields.category.isValid){
        this.readOnly = false;
      }
      else{
        this.readOnly = true;
      }
    },
    'readOnly': function (val) {
      this.$refs.sizeRenderer.setReadOnly(val);
      this.$refs.sizeRenderer.setEditorMode(val);
    }
  },


  data: () => ({
    readOnly: true,
    editorMode: false,
  })
}
</script>

<style scoped>

</style>